module.exports = __webpack_public_path__ + "components/app-store/static/google-play-46357c6a6a02d715837dac2c86a4a951.svg";